module.exports = __webpack_public_path__ + "static/media/Profile pic.83d3b978.jpg";